const mediaItems = [
  {
    title: '暗夜追踪 终极预告',
    duration: '02:35',
    views: '186万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20film%20scene%20with%20man%20in%20tactical%20gear%20running%20through%20rainy%20alleyway%20at%20night%2C%20neon%20reflections%20on%20wet%20ground%2C%20cinematic%20lighting%2C%20intense%20action%20moment%2C%20professional%20film%20still%20quality&width=600&height=340&seq=media-01&orientation=landscape',
    tag: '预告片',
  },
  {
    title: '星河战纪 第三季花絮',
    duration: '05:12',
    views: '92万',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20sci-fi%20movie%20production%20with%20actors%20in%20futuristic%20costumes%20on%20green%20screen%20set%2C%20professional%20film%20crew%20working%2C%20cinematic%20lighting%20setup%2C%20dynamic%20production%20atmosphere&width=600&height=340&seq=media-02&orientation=landscape',
    tag: '花絮',
  },
  {
    title: '都市寓言 导演专访',
    duration: '12:08',
    views: '65万',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20sitting%20in%20interview%20setting%20with%20warm%20studio%20lighting%2C%20professional%20camera%20equipment%20in%20background%2C%20cinematic%20documentary%20style%20portrait%2C%20intellectual%20and%20artistic%20atmosphere&width=600&height=340&seq=media-03&orientation=landscape',
    tag: '专访',
  },
  {
    title: '迷雾深渊 深度解析',
    duration: '08:45',
    views: '48万',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20film%20analysis%20scene%20with%20detective%20board%20filled%20with%20clues%20and%20red%20strings%2C%20dim%20atmospheric%20lighting%2C%20suspenseful%20and%20intellectual%20mood%2C%20cinematic%20composition&width=600&height=340&seq=media-04&orientation=landscape',
    tag: '解析',
  },
  {
    title: '笑闹江湖 精彩片段',
    duration: '03:20',
    views: '137万',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20kung%20fu%20film%20scene%20with%20group%20of%20colorful%20martial%20artists%20in%20humorous%20pose%2C%20bright%20vibrant%20lighting%2C%20traditional%20Chinese%20courtyard%20setting%2C%20playful%20and%20energetic%20atmosphere&width=600&height=340&seq=media-05&orientation=landscape',
    tag: '片段',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">精彩视频</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">媒体精选 · 预告花絮</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">热门影视预告片、幕后花絮与深度专访一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs font-medium whitespace-nowrap">{item.duration}</span>
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">{item.tag}</span>
              </div>
              <div className="p-3">
                <h3 className="font-semibold text-sm text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{item.views} 次播放</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}